module.exports = __webpack_public_path__ + "img/logout.1cbcec93.svg";